import { createSelector } from 'reselect';

const getRulesConfig = (state) => {
    const { views: { view }, config = {} } = state;
    return config[view]?.rules ||  config?.rules || {};
}
// reselect function
export const getRulesSelector = createSelector(
    [getRulesConfig],
    (rules) => (rules)
);
